import { Select } from "@chakra-ui/react"
import { useCallback } from "react"
import { CreateLimitOrder } from "sdk-react/limitOrder/useCreateLimitOrder"
import { DelegateApproval } from "sdk-react/limitOrder/useDelegateApproval"

const deadlines = [
    {
        label: "1 week",
        value: 7 * 24 * 60 * 60,
    },
    {
        label: "1 day",
        value: 1 * 24 * 60 * 60,
    },
    {
        label: "4 hours",
        value: 4 * 60 * 60,
    },
    {
        label: "1 hour",
        value: 1 * 60 * 60,
    },
    {
        label: "30 mins",
        value: 30 * 60,
    },
    {
        label: "5 mins",
        value: 5 * 60,
    },
]

export function LimitOrderDeadlineSetting() {
    const { deadline, setDeadline } = CreateLimitOrder.useContainer()
    const { isApproved } = DelegateApproval.useContainer()

    const handleSelect = useCallback<React.ChangeEventHandler<HTMLSelectElement>>(
        event => {
            setDeadline(Number(event.target.value))
        },
        [setDeadline],
    )

    if (!isApproved) {
        return null
    }

    return (
        <Select fontSize={"sm"} maxW="30%" borderRadius="2xl" defaultValue={deadline} onChange={handleSelect}>
            <optgroup label="Order expires in">
                {deadlines.map(({ label, value }) => (
                    <option style={{ fontSize: "md" }} key={label} value={value}>
                        {label}
                    </option>
                ))}
            </optgroup>
        </Select>
    )
}
